"use client";

import {
  BookOpen,
  BookMarked,
  FileText,
  Newspaper,
  ScrollText,
  Disc,
  Map,
  GraduationCap,
  Database,
} from "lucide-react";

const collections = [
  {
    title: "Printed Books",
    value: "115,000+",
    icon: BookOpen,
  },
  {
    title: "e-Books",
    value: "17,000+",
    icon: BookMarked,
  },
  {
    title: "e-Journals",
    value: "45,000+",
    icon: FileText,
  },
  {
    title: "Daily Newspapers",
    value: "06",
    icon: Newspaper,
  },
  {
    title: "Manuscripts",
    value: "18+",
    icon: ScrollText,
  },
  {
    title: "CD / DVD",
    value: "64+",
    icon: Disc,
  },
  {
    title: "Maps",
    value: "10+",
    icon: Map,
  },
  {
    title: "Thesis",
    value: "7,500+",
    icon: GraduationCap,
  },
];

export default function CollectionSection() {
  return (
    <section className="collection-section">
      <div className="container">
        <div className="heading">
          <span>OUR HOLDINGS</span>
          <h2>Collection at a Glance</h2>
          <p>
            A vast, carefully curated repository of knowledge — print and
            digital — serving Jahangirnagar University.
          </p>
        </div>
{/* 
        <div className="featured-card">
          <div className="featured-left">
            <Database size={50} />
            <div>
              <h3>180,000+</h3>
              <p>Total Library Holdings</p>
            </div>
          </div>

          <div className="badge">
            62,000+ Digital Resources
          </div>
        </div> */}

        <div className="grid">
          {collections.map((item, index) => {
            const Icon = item.icon;

            return (
              <div className="card" key={index}>
                <div className="icon">
                  <Icon size={28} />
                </div>

                <h4>{item.value}</h4>
                <p>{item.title}</p>
              </div>
            );
          })}
        </div>

        {/* <div className="bottom-stats">
          <div>
            <h3>180,000+</h3>
            <span>Physical Items</span>
          </div>

          <div>
            <h3>62,000+</h3>
            <span>Digital Resources</span>
          </div>

          <div>
            <h3>08</h3>
            <span>Collection Categories</span>
          </div>
        </div> */}
      </div>

      <style jsx>{`
        .collection-section {
          padding: 100px 0;
          background: linear-gradient(
            135deg,
            #faf7f5,
            #ffffff
          );
          overflow: hidden;
        }

        .container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .heading {
          text-align: center;
          max-width: 800px;
          margin: 0 auto 60px;
        }

        .heading span {
          display: inline-block;
          padding: 10px 18px;
          border-radius: 999px;
          background: rgba(176, 125, 98, 0.1);
          color: #b07d62;
          font-weight: 700;
          margin-bottom: 20px;
        }

        .heading h2 {
          font-size: clamp(2.5rem, 5vw, 4rem);
          font-weight: 800;
          color: #2d3748;
          margin-bottom: 15px;
        }

        .heading p {
          color: #64748b;
          line-height: 1.8;
          font-size: 1.05rem;
        }

        .featured-card {
          background: linear-gradient(
            135deg,
            #7e695e,
            #b07d62
          );
          color: white;
          border-radius: 30px;
          padding: 35px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 20px;
          margin-bottom: 40px;
          box-shadow: 0 25px 50px rgba(126, 105, 94, 0.25);
        }

        .featured-left {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .featured-card h3 {
          font-size: 3rem;
          margin: 0;
        }

        .featured-card p {
          margin: 0;
          opacity: 0.9;
        }

        .badge {
          background: rgba(255, 255, 255, 0.15);
          padding: 12px 20px;
          border-radius: 999px;
          font-weight: 600;
          backdrop-filter: blur(10px);
        }

        .grid {
          display: grid;
          grid-template-columns: repeat(
            auto-fit,
            minmax(220px, 1fr)
          );
          gap: 24px;
        }

        .card {
          background: #fff;
          border-radius: 24px;
          padding: 28px;
          transition: all 0.35s ease;
          border: 1px solid rgba(176, 125, 98, 0.12);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
        }

        .card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(176, 125, 98, 0.2);
        }

        .icon {
          width: 65px;
          height: 65px;
          border-radius: 18px;
          background: linear-gradient(
            135deg,
            #7e695e,
            #b07d62
          );
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .card h4 {
          font-size: 2rem;
          margin-top: 18px;
          margin-bottom: 8px;
          color: #1e293b;
        }

        .card p {
          color: #64748b;
          margin: 0;
        }

        .bottom-stats {
          margin-top: 50px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        .bottom-stats div {
          background: white;
          padding: 30px;
          border-radius: 24px;
          text-align: center;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
        }

        .bottom-stats h3 {
          font-size: 2.3rem;
          color: #7e695e;
          margin: 0 0 8px;
        }

        .bottom-stats span {
          color: #64748b;
        }

        @media (max-width: 768px) {
          .featured-card {
            flex-direction: column;
            text-align: center;
          }

          .featured-left {
            flex-direction: column;
          }

          .bottom-stats {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
}